import app from 'Cloud/Application/app';
import { IS_PUBLIC } from 'reactApp/appHelpers/configHelpers';
import { showWelcome } from 'reactApp/modules/welcome/welcome.module';
import { store } from 'reactApp/store';

export default () => {
    app.on('page:start routeEnd', () => {
        if (!(app.user.isNewbie() && !IS_PUBLIC && !app.user.isSocialUser())) {
            return;
        }

        store.dispatch(showWelcome());
    });
};
